// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.member-section {
    padding: 78px 100px 145px;
}

.right-content-wrap {
    max-width: 630px;
}

.left-content-wrap {
    max-width: 630px;
}

.member-section .title {
    font-size: 46px;
    margin-bottom: 1rem;
    font-weight: 600;
    line-height: 58px;
    color: #242424;
    text-align: left;
    margin-top: 20px;
    font-family: "Inter", sans-serif;
}

.member-section .title span {
    font-weight: 800;
}

.member-section .description {
    font-size: 22px;
    line-height: 33px;
    font-weight: 400;
    color: #242424;
    margin: 24px 0px;
}

.member-section a {
    text-decoration: none;
}

.member-section a:hover {
    text-decoration: none !important;
}

.green-btn {
    background-color: #06EFC5;
    color: #242424;
    font-size: 18.33px;
    font-weight: 800;
    line-height: 13.33px;
    border: 1px solid transparent;
    padding: 18px 32px;
    display: block;
}

.green-btn-mob {
    display: none;
}

.pink-btn {
    background-color: #F495D3;
    border-radius: 49px;
    padding: 2px 15px;
    color: #ffffff;
    font-size: 22px;
    line-height: 33px;
    font-weight: 600;
    border: 1px solid transparent;
}

.blue-btn {
    background-color: #38BBF4;
    border-radius: 49px;
    padding: 2px 15px;
    color: #ffffff;
    font-size: 22px;
    line-height: 33px;
    font-weight: 600;
    border: 1px solid transparent;
}

.member-sec-wrap {
    margin-bottom: 100px;
}

@media (max-width: 768px) {
    .member-section {
        padding: 46px 25px;
    }

    .member-sec-wrap {
        flex-direction: column-reverse;
    }

    .member-section .title {
        font-size: 25px;
        line-height: 39px;
        margin-top: 20px;
        margin-bottom: 0px;
    }

    .member-section .description {
        font-size: 15px;
        line-height: 19px;
        padding: 20px 0px;
        margin: 0px;
    }

    .pink-btn {
        font-size: 12px;
        line-height: 33px;
    }

    .green-btn {
        display: none;
    }

    .green-btn-mob {
        display: block;
        background-color: #06EFC5;
        color: #242424;
        font-size: 15px;
        font-weight: 800;
        line-height: 13.33px;
        border: 1px solid transparent;
        padding: 18px 32px;
        width: 100%;
        margin: 50px 0px 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Member/Member.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,6BAA6B;QAC7B,kBAAkB;QAClB,WAAW;QACX,qBAAqB;IACzB;AACJ","sourcesContent":[".member-section {\n    padding: 78px 100px 145px;\n}\n\n.right-content-wrap {\n    max-width: 630px;\n}\n\n.left-content-wrap {\n    max-width: 630px;\n}\n\n.member-section .title {\n    font-size: 46px;\n    margin-bottom: 1rem;\n    font-weight: 600;\n    line-height: 58px;\n    color: #242424;\n    text-align: left;\n    margin-top: 20px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.member-section .title span {\n    font-weight: 800;\n}\n\n.member-section .description {\n    font-size: 22px;\n    line-height: 33px;\n    font-weight: 400;\n    color: #242424;\n    margin: 24px 0px;\n}\n\n.member-section a {\n    text-decoration: none;\n}\n\n.member-section a:hover {\n    text-decoration: none !important;\n}\n\n.green-btn {\n    background-color: #06EFC5;\n    color: #242424;\n    font-size: 18.33px;\n    font-weight: 800;\n    line-height: 13.33px;\n    border: 1px solid transparent;\n    padding: 18px 32px;\n    display: block;\n}\n\n.green-btn-mob {\n    display: none;\n}\n\n.pink-btn {\n    background-color: #F495D3;\n    border-radius: 49px;\n    padding: 2px 15px;\n    color: #ffffff;\n    font-size: 22px;\n    line-height: 33px;\n    font-weight: 600;\n    border: 1px solid transparent;\n}\n\n.blue-btn {\n    background-color: #38BBF4;\n    border-radius: 49px;\n    padding: 2px 15px;\n    color: #ffffff;\n    font-size: 22px;\n    line-height: 33px;\n    font-weight: 600;\n    border: 1px solid transparent;\n}\n\n.member-sec-wrap {\n    margin-bottom: 100px;\n}\n\n@media (max-width: 768px) {\n    .member-section {\n        padding: 46px 25px;\n    }\n\n    .member-sec-wrap {\n        flex-direction: column-reverse;\n    }\n\n    .member-section .title {\n        font-size: 25px;\n        line-height: 39px;\n        margin-top: 20px;\n        margin-bottom: 0px;\n    }\n\n    .member-section .description {\n        font-size: 15px;\n        line-height: 19px;\n        padding: 20px 0px;\n        margin: 0px;\n    }\n\n    .pink-btn {\n        font-size: 12px;\n        line-height: 33px;\n    }\n\n    .green-btn {\n        display: none;\n    }\n\n    .green-btn-mob {\n        display: block;\n        background-color: #06EFC5;\n        color: #242424;\n        font-size: 15px;\n        font-weight: 800;\n        line-height: 13.33px;\n        border: 1px solid transparent;\n        padding: 18px 32px;\n        width: 100%;\n        margin: 50px 0px 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
